
import { nodeName } from "jquery";
import { Platform, StyleSheet, Dimensions } from "react-native";
import { widthInPercentage } from "../../utils/appUtils";
//const windowWidth = Dimensions.get("window").width;
const windowHeight = Dimensions.get("window").height;

export default StyleSheet.create({
  nav: {
    position: Platform.OS === "web" ? "fixed" : null,
    width: "100%",
    backgroundColor: "#fff",
    zIndex: 99999,
  },
  firstContaineriew: {
    flexDirection: "row",
    marginTop: "2%",
  },
  firstContaineriew_LDPI: {
    flexDirection: "column",
    marginTop: 100,
  },
  firstContaineriew_MDPI: {
    flexDirection: "column",
    marginTop: 40,
  },
  firstContaineriew_HDPI: {
    flexDirection: "column",
    marginTop: "13%",
  },
  firstContaineriew_XHDPI: {
    flexDirection: "column",
    marginTop: "13%",
  },
  firstContaineriew_XXHDPI: {
    flexDirection: "column",
    marginTop: "13%",
  },
  firstContaineriew_XXXHDPI: {
    flexDirection: "column",
    marginTop: "13%",
  },
  firstContainer: {
    margin: "2%",
    boxSizing: "border-box",
    width: "65%",
    backgroundColor: "#FFFFFF",
    border: "1px solid #FBEBDF",
    boxShadow: "0px 10px 21px rgba(196, 112, 45, 0.14)",
    borderRadius: "8px",
  },
  thirdContaineriew: {
    boxSizing: "border-box",
    width: "100%",
    height: "77px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #FBEBDF",
    boxShadow: "0px 10px 21px rgba(196, 112, 45, 0.14)",
    borderRadius: "8px",
    justifyContent: "center",
  },
  thirdContainer: {
    display: "flex",
    margin: "2%",
    height: "77px",
    boxSizing: "border-box",
    width: "65%",
    backgroundColor: "#FFFFFF",
    border: "1px solid #FBEBDF",
    boxShadow: "0px 10px 21px rgba(196, 112, 45, 0.14)",
    borderRadius: "8px",
    justifyContent: "center",
    alignItems: "center",
  },
  thirdContainer_MDPI: {
    width: "97%",
    height: "150px",
  },
  thirdContainer_HDPI: {
    width: "97%",
    height: "150px",
    flexDirection: "column",
  },
  thirdContainer_XHDPI: {
    width: "97%",
    height: "150px",
  },
  thirdContainer_XXHDPI: {
    width: "97%",
    height: "150px",
  },
  thirdContainer_XXXHDPI: {
    width: "97%",
    height: "150px",
  },
  insideThirdContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: "5%",
    width: "90%",
    height: "77px",
  },

  thirdContainerQuickPay_MDPI: {
    width: "97%",
    height: "150px",
    flexDirection: "column",
  },
  thirdContainerQuickPay_HDPI: {
    width: "97%",
    height: "150px",
    flexDirection: "column",
  },
  thirdContainerQuickPay_XHDPI: {
    width: "97%",
    flexDirection: "column",

    height: "150px",
  },
  thirdContainerQuickPay_XXHDPI: {
    width: "60%",
    height: "150px",
    flexDirection: "column",
  },
  thirdContainerQuickPay_XXXHDPI: {
    width: "60%",
    height: "150px",
    flexDirection: "column",
  },

  insideThirdContainer_MDPI: {
    height: 120,
    display: "flex",
    flexDirection: "column",
    // justifyContent: 'space-around',
    alignItems: "center",
  },
  insideThirdContainer_HDPI: {
    height: 120,
    display: "flex",
    flexDirection: "column",
    // justifyContent: 'space-around',
    alignItems: "center",
  },
  insideThirdContainer_XHDPI: {
    height: 120,
    display: "flex",
    flexDirection: "column",
    // justifyContent: 'space-around',
    alignItems: "center",
  },
  insideThirdContainer_XXHDPI: {
    height: 120,
    display: "flex",
    flexDirection: "column",
    // justifyContent: 'space-around',
    alignItems: "center",
  },
  firstContainer_MDPI: { width: "97%" },
  firstContainer_HDPI: { width: "97%" },
  firstContainer_XHDPI: { width: "97%" },
  firstContainer_XHDPI: { width: "97%" },
  firstContainer_XXHDPI: { width: "97%" },
  firstContainer_XXXHDPI: { width: "97%" },

  insideContainer: {
    margin: "3%",
    width: "94%",
    height: "180px",
  },
  insideContainer_MDPI: {
    margin: "3%",
    width: "95%",
    height: "180px",
  },
  radioButtonView: { flexDirection: "row", flex: 1 },
  VerificationRadioButton: { flexDirection: "row", marginVertical: 5 },

  radioButtonView_MDPI: { flexDirection: "column", marginLeft: "5%" },
  firstHeaderView: { flexDirection: "row", padding: "2%" },

  css_baseline: {
    width: "617px",
    backgroundColor: "grey",
    height: "2px",
    alignItems: "center",
    border: "1px solid #E3E3E3",
    marginVertical: "15%",
    marginLeft: "2%",
  },

  imageContainer: {
    width: "320px",
    height: "205px",
    borderRadius: "50px",
    marginTop: "2%",
    zIndex: -1,
  },
  imageContainer_LDPI: {
    width: "100%",
    height: "180px",
    marginRight: "30px",
    top: 0,
  },
  imageContainer_MDPI: {
    width: "100%",
    height: "180px",
    marginRight: "30px",
  },
  imageContainer_HDPI: {
    width: "100%",
    height: "180px",
    top: 0,
  },
  imageContainer_XHDPI: {
    width: "100%",
    height: "300px",
    top: 0,
  },
  imageContainer_XXHDPI: {
    width: "100%",
    height: "300px",
    top: 0,
  },
  imageContainer_XXXHDPI: {
    width: "100%",
    height: "300px",
    top: 0,
  },
  CibilImageView: { width: 320, height: "100%", borderRadius: "20px" },
  CibilImageView_LDPI: {
    marginHorizontal: "2%",
    marginVertical: "1%",
    width: 254,
    height: "180px",
  },
  CibilImageView_MDPI: {
    marginHorizontal: "2%",
    width: "97%",
    height: "180px",
  },
  CibilImageView_HDPI: {
    marginHorizontal: "2%",
    width: "97%",
    height: "180px",
  },
  CibilImageView_XHDPI: {
    marginHorizontal: "2%",
    width: "97%",
    height: "280px",
  },
  CibilImageView_XXHDPI: {
    marginHorizontal: "2%",
    width: "97%",
    height: "280px",
  },
  CibilImageView_XXXHDPI: {
    marginHorizontal: "2%",
    width: "97%",
    height: "280px",
  },
  CreditBuilderLogo: { width: "234px", height: "71.85px", flexShrink: 0 },

  // CreditBuilder View in dashboard
  CreditBuilderView: {
    backgroundColor: "white",
    width: "320px",
    height: "150px",
    borderRadius: "10px",
  },
  CreditBuilderView_LDPI: {
    width: "97%",
    height: "150px",
    marginHorizontal: "2%",
  },
  CreditBuilderView_MDPI: {
    width: "97%",
    height: "150px",
    marginHorizontal: "2%",
  },
  CreditBuilderView_HDPI: {
    width: "97%",
    height: "150px",
    marginHorizontal: "2%",
  },
  CreditBuilderView_XHDPI: {
    width: "97%",
    height: "150px",
    marginHorizontal: "2%",
  },
  CreditBuilderView_XXHDPI: {
    width: "97%",
    height: "150px",
    marginHorizontal: "2%",
  },
  CreditBuilderView_XXHDPI: {
    width: "97%",
    height: "150px",
    marginHorizontal: "2%",
  },

  CreditBuilderText: {
    fontFamily: "Mulish",
    fontSize: "35px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "150%",
    textTransform: "capitalize",
  },
  creditBuilderPrimaryText: {
    color: "#A31D22",
    fontFamily: "Mulish",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "150%",
    textTransform: "capitalize",
  },

  creditBuilderSecondaryText: {
    color: "#074A86",
    fontFamily: "Mulish",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "150%",
    letterSpacing: "0.88px",
    textTransform: "capitalize",
  },

  transparentButtonView: {
    width: "45%",
    position: "absolute",
    top: "25%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: 30,
  },
  transparentButtonView_LDPI: {
    top: "20%",
    padding: 3,
  },
  transparentButtonView_MDPI: {
    top: "20%",
    padding: 3,
    left: "45%",
  },
  transparentButtonView_HDPI: {
    top: "20%",
    padding: 3,
  },
  transparentButtonView_XXHDPI: {
    top: "23%",
    padding: 5,
    left: "45%",
  },

  transparentButtonViewQuickPay: {
    width: "45%",
    position: "absolute",
    top: "20%",
    left: "45%",
    transform: "translate(-50%, -50%)",
    fontSize: "14px",
    cursor: "pointer",
    borderRadius: 30,
  },

  transparentButtonViewQuickPay_LDPI: {
    top: "20%",
    left: "50%",
  },
  transparentButtonViewQuickPay_MDPI: {
    top: "20%",
    left: "50%",
  },
  transparentButtonViewQuickPay_HDPI: {
    top: "20%",
    left: "50%",
  },
  transparentButtonViewQuickPay_XXHDPI: {
    top: "23%",
    left: "50%",
  },
  TransparentButton: {
    justifyContent: "center",
    alignItems: "center",
    height: 30,

    borderRadius: 30,
  },
  ButtonText: {
    fontSize: 15,
    textAlign: "center",
    fontFamily: "Mulish",
    fontWeight: "bold",
  },

  secondContainer: {
    boxSizing: "border-box",
    width: "65%",
    height: "204px",
    marginLeft: "2%",
    backgroundColor: "#FFFFFF",
    border: "1px solid #FBEBDF",
    boxShadow: "0px 10px 21px rgba(196, 112, 45, 0.14)",
    borderRadius: "8px",
  },
  secondContainer_MDPI: { width: "97%", marginTop: "5%" },
  secondContainer_HDPI: { width: "97%" },
  secondContainer_XHDPI: { width: "97%" },
  secondContainer_XXHDPI: { width: "97%" },
  secondContainer_XXXHDPI: { width: "97%" },

  textFieldStyle: { backgroundColor: "red" },

  headerText: {
    width: "100%",
    height: "24px",
    fontFamily: "Mulish ",
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "16px",
    lineHeight: "150%",
    color: "#333333",
  },
  declareText: {
    left: "56px",
    top: "73px",
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#333333",
  },
  subHeaderText: {
    width: "215px",
    height: "16px",
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "130%",
    color: "#787F89",
  },
  numberText: {
    height: "26px",
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "130%",
  },
  secondaryText: {
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "138%",
    letterSpacing: "-0.01em",
  },

  //side menu
  menuView: {
    width: "269px",
    marginTop: "10%",
  },
  menuView_XHDPI: {
    marginTop: "25%",
  },
  menuView_XXHDPI: {
    marginTop: "25%",
  },
  menuView_XXXHDPI: {
    marginTop: "25%",
  },
  menuCardView: { display: "flex", flexDirection: "column" },
  menuNameView: {
    width: "229px",
    height: "42px",
    marginHorizontal: "5%",
    marginVertical: "2%",
    borderRadius: "8px",
    alignItems: "start",
    justifyContent: "center",
  },

  insideMenu: {
    marginLeft: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  menuName: {
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "12px",
    color: "#787F89",
  },

  whatsappImageView: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  whatsappConatiner: {
    boxSizing: "border-box",
    width: "229px",
    height: "134px",
    left: "20px",
    backgroundColor: "#FAFAFA",
    borderRadius: "8px",
    padding: "4%",
    marginTop: "25%",
  },
  whatappButtonView: {
    width: "73px",
    marginHorizontal: "15%",
    marginVertical: "5%",
  },
  pq_checkboxView: {
    flexDirection: "row",
    margin: "3%",
  },
  whatsappText: {
    fontFamily: "Mulish",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0em",
    textAlign: "left",
    color: "#333333",
  },
  pq_terms_text: {
    fontFamily: "Mulish",
    textDecorationLine: "underline",
    color: "#F37E20",
    marginLeft: 4,
  },

  //Modal styling
  overdueHieght: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    zIndex: -9,
    width: "593px",
    left: "386px",
    top: "314px",
    background: "#FFFFFF",
    borderRadius: "8px",
  },

  calenderView: {
    flexDirection: "column",
    backgroundColor: "white",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    width: widthInPercentage(100),
    borderRadius: 10,
  },
  verificationImage: {
    width: 25,
    height: 25,
    marginLeft: 5,
  },

  //Accordian

  accordianMainView: {
    display: "flex",
    flexDirection: "row",
    marginVertical: 10,
  },
  accordianMainView_LDPI: {
    display: "flex",
    flexDirection: "column",
    marginVertical: 10,
  },

  accordianSubView: {
    width: "50%",
    // height: 130,
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
  },
  accordianSubView_LDPI: {
    width: "100%",
    // height: 130,
    marginVertical: 10,

    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
  },

  accordianNumber: {
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "130%",
    color: "#000000",
  },

  // third view

  loanButtonView_MDPI: { width: "45%", margin: "2%" },
  loanBranchesSubText: {
    fontFamily: "mulish",
    color: "#787F89",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: 14,
  },
  loanBranchesSubText_XXXHDPI: {
    width: "60%",
  },

  //Overdue Subheader Text

  overdueSubheaderText: {
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "120%",
    color: "#787F89",
  },

  // Nudge message
  verificationNudge: {
    justifyContent: "center",
    alignItems: "left",
    padding: "1%",
    marginVertical: "2%",
  },
  dashoardNudgeView: {
    width: "100%",
    backgroundColor: "#fff2e3",
    borderRadius: "8px",
    color: "red",
    justifyContent: "center",
  },
  dashoardNudgeSubView: {
    width: "100%",
    flexDirection: "row",
  },
  dashoardNudgeSubView_LDPI: {
    gap: 10,
  },
  nudgeText: {
    textAlign: "left",
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "130%",
    letterSpacing: "-0.01em",
    color: "#333333",
  },
  dashoardNudgeImage: {
    width: "9px",
    height: "12px",
    top: "3px",
  },

  //Radio text
  radioText: {
    marginLeft: 10,
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "11px",
    lineHeight: "14px",
    textTransform: "uppercase",
    color: "#333333",
  },

  //image slider
  imageSliderView: {
    alignItems: "center",
    justifyContent: "center",
  },

  imageSlider: { width: "60%", height: 350, aspectRatio: "auto" },
  imageSlider_XXXHDPI: {
    width: "80%",
    height: 280,
    marginVertical: 30,
  },
  imageSlider_XXHDPI: {
    width: "80%",
    height: 280,
    marginVertical: 30,
  },
  imageSlider_XHDPI: {
    width: "80%",
    height: 280,
    marginVertical: 30,
  },

  imageSlider_HDPI: {
    width: "80%",
    height: 280,
    marginVertical: 30,
  },

  imageSlider_MDPI: {
    width: "80%",
    height: 280,
    marginVertical: 30,
  },
  imageSlider_LDPI: {
    width: "80%",
    height: 280,
    marginVertical: 30,
  },

  quickPayImageSlider: { width: "100%", height: 180, borderRadius: "10px" },
  quickPayImageSlider_LDPI: {
    width: "100%",
    height: 120,
    borderRadius: "10px",
  },
  quickPayImageSlider_MDPI: {
    width: "100%",
    height: 130,
    borderRadius: "10px",
  },

  // credit builder
  creditTopView: {
    marginTop: "0px",
  },
  creditTopView_MDPI: {
    marginTop: 40,
  },
  creditTopView_HDPI: {
    marginTop: 40,
  },
  creditTopView_XHDPI: {
    marginTop: 40,
  },
  creditTopView_XXHDPI: {
    marginTop: 40,
  },

  header: {
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "138%",
    color: "orange",
  },
  subheader: {
    fontFamily: "'Mulish'",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "138%",
    color: "brown",
    fontStyle: "italic",
  },
  LastScreenContainer: {
    marginVertical: "2%",
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "black",
    borderRadius: "8px",
    justifyContent: "center",
    paddingVertical: "2%",
  },
  SecondScreenContainer: {
    backgroundColor: "#FFF",
    borderWidth: 1,
    borderColor: "#FFEFE1",
    borderRadius: "8px",
    justifyContent: "center",
    padding: "2%",
    flexShrink: 0,
    margin: "1%",
  },
  SecondScreenText: {
    fontFamily: "Mulish",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "138%",
    textAlign: "left",
    color: "black",
    marginTop: 5,
    marginLeft: 10,
  },
  SecondScreenTextContent: {
    marginLeft: 10,
    display: "list-item",
    fontFamily: "mulish",
    fontSize: 15,
    listStyle: "disc outside none",
  },
  //FAQ styles
  faqHeader: {
    color: "var(--ICICI-Black, #333)",
    fontFamily: "Mulish",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "130%",
  },
  menuBarText: {
    fontFamily: "Mulish",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "150%",
    textTransform: "capitalize",
  },
  menuBarStyle: {
    flexDirection: "row",
    marginHorizontal: "20px",
  },
  searchBar: {
    display: "flex",
    width: "637px",
    padding: 15,
    justifyContent: "space-between",
    alignItems: "center",
    borderWidth: "2px",
    borderColor: "#f37e20",
    borderRadius: "24px",
    border: "1px solid #f37e20",
    backgroundColor: "#fff",
    position: "relative",
  },
  searchBar_LDPI: {
    width: 300,
  },
  searchBar_MDPI: { width: "100%" },
  searchBar_HDPI: { width: "100%" },
  searchBar_XHDPI: { width: 500 },
  searchBar_XXHDPI: { width: 500 },

  searchIcon: {
    width: 15,
    height: 15,
    bottom: "50%",
    display: "flex",
    left: "600px",
  },
  searchIcon_LDPI: { left: "270px", bottom: "35px" },
  searchIcon_MDPI: { left: "320px", bottom: "35px" },
  searchIcon_HDPI: { left: "410px", bottom: "35px" },
  searchIcon_XHDPI: { left: "460px", bottom: "25px" },
  searchIcon_XXHDPI: { left: "460px" },

  //QuickPay
  CibilImageViewQuickPay: { width: 281, height: "180px", borderRadius: "20px" },
  CibilImageViewQuickPay_LDPI: {
    marginHorizontal: "3%",
    marginVertical: "1%",
    width: 254,
    height: "180px",
    marginLeft: "1%",
  },
  CibilImageViewQuickPay_MDPI: {
    marginHorizontal: "3%",
    width: "97%",
    marginVertical: "2%",
    resizeMode: "stretch",
  },
  CibilImageViewQuickPay_HDPI: {
    marginHorizontal: "2%",
    marginVertical: "2%",

    width: "97%",
  },

  imageContainerQuickPay_LDPI: {
    width: "80%",
    height: "200px",
    marginHorizontal: "35px",
  },
  imageContainerQuickPay_MDPI: {
    width: "80%",
    height: "200px",
    marginHorizontal: "35px",
  },
  imageContainerQuickPay_HDPI: {
    width: "100%",
    height: "300px",
    top: 0,
  },
  imageContainerQuickPay_XHDPI: {
    width: "100%",
    height: "300px",
    top: 0,
  },
  imageContainerQuickPay_XXHDPI: {
    width: "320px",
    height: "300px",
    top: 0,
  },
  imageContainerQuickPay_XXXHDPI: {
    width: "100%",
    height: "300px",
    top: 0,
  },
  AccountClosureText: {
    color: '#AD1E23',
    textAlign: 'right',
    fontFamily: 'Mulish',
    fontSize: 14,
    marginRight: '4%',
    textDecorationLine: 'underline',
  },

});
